import React from 'react';
import { Card, Button, Space, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ProcessedImagePreviewProps {
  imageUrl: string | null;
  imageInfo?: {
    name: string;
    size: number;
    width?: number;
    height?: number;
    format?: string;
  };
  onDownload: () => void;
}

const ProcessedImagePreview: React.FC<ProcessedImagePreviewProps> = ({ 
  imageUrl, 
  imageInfo, 
  onDownload 
}) => {
  if (!imageUrl) {
    return null;
  }

  // 格式化文件大小
  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };

  return (
    <Card 
      title="处理后的图片" 
      extra={
        <Button 
          type="primary" 
          icon={<DownloadOutlined />} 
          onClick={onDownload}
        >
          下载
        </Button>
      }
    >
      <div style={{ textAlign: 'center' }}>
        <img 
          src={imageUrl} 
          alt="处理后的图片" 
          style={{ 
            maxWidth: '100%', 
            maxHeight: '300px',
            objectFit: 'contain'
          }} 
        />
      </div>
      
      {imageInfo && (
        <div style={{ marginTop: '16px' }}>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text>文件名: {imageInfo.name}</Text>
            <Text>文件大小: {formatFileSize(imageInfo.size)}</Text>
            {imageInfo.width && imageInfo.height && (
              <Text>尺寸: {imageInfo.width} x {imageInfo.height} 像素</Text>
            )}
            {imageInfo.format && (
              <Text>格式: {imageInfo.format.toUpperCase()}</Text>
            )}
          </Space>
        </div>
      )}
    </Card>
  );
};

export default ProcessedImagePreview;